import React, { useEffect, useRef, useState } from 'react';

import Store from '@/core/lib/new-architecture/store';
import { useTranslationContext } from '@/core/lib/translation/translation.context';

interface CatalogueSeoTextProps {}
const CatalogueSeoText: React.FC<CatalogueSeoTextProps> = () => {
  const { t } = useTranslationContext(['catalogue']);
  const [isExpanded, setIsExpanded] = useState<boolean>(false);
  const seoTextRef = useRef<HTMLParagraphElement>(null);
  const [isClamped, setIsClamped] = useState<boolean>(false);
  const { data: catalogue } = Store.catalogue.useCatalogue();
  const translationKey = catalogue?.getCatalogueSeoTranslationKey();

  useEffect(() => {
    const element = seoTextRef.current;
    if (element) {
      const currentStyle = window.getComputedStyle(element);
      const lineClamp = parseInt(currentStyle.getPropertyValue('-webkit-line-clamp'), 10);

      if (lineClamp > 0 && currentStyle.getPropertyValue('overflow') === 'hidden') {
        setIsClamped(element.scrollHeight > element.clientHeight);
        return;
      }
      setIsClamped(false);
    }
  }, [catalogue]);

  if (!translationKey) return null;

  const handleOnClick = () => {
    setIsExpanded(!isExpanded);
  };

  return (
    <section className="my-3">
      <p className="text-body-primary font-semibold">{t(`seo.${translationKey}.title`, { ns: 'catalogue' })}</p>
      <p ref={seoTextRef} className={`text-body-secondary my-1 ${isExpanded ? '' : 'line-clamp-1 lg:line-clamp-2'}`}>
        {t(`seo.${translationKey}.text`, { ns: 'catalogue' })}
      </p>
      {isClamped && (
        <button type="button" onClick={handleOnClick} className="text-body-secondary font-medium underline">
          {t(isExpanded ? 'seo.expand-button.see-less' : 'seo.expand-button.see-more', { ns: 'catalogue' })}
        </button>
      )}
    </section>
  );
};

export default CatalogueSeoText;
